/* Packrift order import, 2026-09-24. Parse on device; submit only reviewed text. */
(function () {
  'use strict';
  var root = document.getElementById('pr-bulk-quote');
  if (!root || root.querySelector('[data-packrift-bulk-quote-posted-successfully="true"]')) return;
  var form = root.querySelector('form'), text = document.getElementById('pr-quote-sku');
  if (!form || !text) return;
  var modeField = document.getElementById('pr-quote-intake-mode');
  var rowPanel = document.getElementById('pr-order-rows-panel'), rows = document.getElementById('pr-order-rows');
  var importPanel = document.getElementById('pr-order-import'), fileInput = document.getElementById('pr-order-file');
  var reviewLabel = document.getElementById('pr-order-review-label'), reviewed = document.getElementById('pr-order-reviewed');
  var error = document.getElementById('pr-order-error'), status = document.getElementById('pr-order-import-status');
  var quantity = document.getElementById('pr-quote-quantity'), mode = 'paste', imported = false, rowDerived = false, busy = false, sequence = 0;
  var LIMIT = 20000, MAX_FILE = 5 * 1024 * 1024;
  var buttons = Array.from(root.querySelectorAll('[data-order-mode]'));
  root.querySelector('.pr-order__modes').hidden = false;

  function fail(message) { error.textContent = message; error.hidden = false; }
  function clearError() { error.hidden = true; error.textContent = ''; }
  function clearProduct() {
    var product = document.getElementById('pr-quote-product');
    if (product) { product.hidden = true; Array.from(product.querySelectorAll('input,button')).forEach(function (el) { el.disabled = true; }); }
    text.removeAttribute('data-auto'); quantity.removeAttribute('data-auto');
  }
  function serializeRows() {
    return Array.from(rows.children).map(function (row) {
      var item = row.querySelector('[data-item]').value.trim();
      var qty = row.querySelector('[data-qty]').value;
      var unit = row.querySelector('[data-unit]').value;
      return item ? item + ' — quantity: ' + qty + ' ' + unit : '';
    }).filter(Boolean).join('\n');
  }
  function updateContract() {
    if (mode === 'rows') {
      text.value = serializeRows(); modeField.value = 'item_rows';
    } else {
      modeField.value = imported ? 'imported_order' : (rowDerived || /\n|\b(?:pieces?|units?|packs?|cases?|pallets?|rolls?|qty|quantity)\b/i.test(text.value.trim()) ? 'item_rows' : 'simple');
    }
    if (modeField.value !== 'simple') clearProduct();
    document.getElementById('pr-order-single-quantity').hidden = !quantity.value.trim() && (mode === 'rows' || imported || /\n/.test(text.value.trim()));
    reviewLabel.hidden = !imported; reviewed.required = imported;
  }
  function addRow(item, qty, unit) {
    if (rows.children.length >= 100) { fail('For more than 100 items, paste your list or email the order to support@packrift.com.'); return; }
    var row = document.createElement('div'); row.className = 'pr-order__item';
    // Only fixed markup enters innerHTML. Buyer and file contents use value/textContent.
    row.innerHTML = '<label><span class="pr-quote__label">Item or specification</span><input data-item type="text" maxlength="500" placeholder="SKU, supplier item number, link or dimensions"></label>' +
      '<div class="pr-order__item-controls"><label><span class="pr-quote__label">Quantity</span><input data-qty type="number" inputmode="numeric" min="1" max="100000000" step="1" placeholder="500"></label>' +
      '<label><span class="pr-quote__label">Unit</span><select data-unit><option value="pieces">Pieces</option><option value="packs">Packs</option><option value="cases">Cases</option><option value="rolls">Rolls</option><option value="pallets">Pallets</option><option value="unit to confirm">Not sure</option></select></label>' +
      '<button type="button" class="pr-order__secondary" aria-label="Remove item">Remove</button></div>';
    row.querySelector('[data-item]').value = item || '';
    row.querySelector('[data-qty]').value = qty || '';
    row.querySelector('[data-unit]').value = unit || 'pieces';
    row.querySelector('button').addEventListener('click', function () {
      if (rows.children.length === 1) { row.querySelector('[data-item]').value = ''; row.querySelector('[data-qty]').value = ''; }
      else row.remove();
      updateContract();
    });
    row.addEventListener('input', updateContract); rows.appendChild(row);
    Array.from(row.querySelectorAll('input')).forEach(function (input) { input.required = mode === 'rows'; });
    return row;
  }
  function setMode(next) {
    if (busy) return;
    clearError();
    if (mode === 'rows') text.value = serializeRows();
    if (next === 'rows' && mode !== 'rows' && text.value.trim()) {
      // Do not guess quantities from existing invoice/paste text or discard it.
      fail('Your list is already filled in. You can edit it below, or clear it before starting item rows.');
      text.focus(); return;
    }
    mode = next;
    if (mode === 'rows') { imported = false; rowDerived = true; if (!rows.children.length) addRow(); }
    rowPanel.hidden = mode !== 'rows'; importPanel.hidden = mode !== 'file';
    document.getElementById('pr-order-text-label').hidden = mode === 'rows';
    text.required = mode !== 'rows';
    Array.from(rows.querySelectorAll('input')).forEach(function (input) { input.required = mode === 'rows'; input.disabled = mode !== 'rows'; });
    buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.orderMode === mode)); });
    updateContract();
  }
  buttons.forEach(function (button) { button.addEventListener('click', function () { setMode(button.dataset.orderMode); }); });
  document.getElementById('pr-order-add').addEventListener('click', function () { var row = addRow(); if (row) row.querySelector('input').focus(); });
  text.addEventListener('input', function () { clearError(); reviewed.checked = false; updateContract(); });

  function loadScript(url, globalName) {
    if (window[globalName]) return Promise.resolve(window[globalName]);
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script'); script.src = url;
      script.onload = function () { window[globalName] ? resolve(window[globalName]) : reject(new Error('The file reader did not load. Please try again or paste the list.')); };
      script.onerror = function () { script.remove(); reject(new Error('The file reader could not load. Please try again or paste the list.')); };
      document.head.appendChild(script);
    });
  }
  function assertLength(value) {
    if (value.length > LIMIT) throw new Error('This order is too long for the form. Please email the original to support@packrift.com, or import a smaller list. Nothing was added.');
    if (value.trim().length < 3) throw new Error('No readable order text was found. For a scanned invoice, email the original to support@packrift.com or paste your item list.');
    return value.trim();
  }
  async function extract(file) {
    if (!file || file.size === 0) throw new Error('Choose a file with an item list. This file is empty.');
    if (file.size > MAX_FILE) throw new Error('Choose a file smaller than 5 MB, or email the original to support@packrift.com.');
    var ext = file.name.split('.').pop().toLowerCase();
    if (['txt', 'csv', 'tsv'].includes(ext)) return assertLength((await file.text()).replace(/^\uFEFF/, ''));
    if (ext === 'pdf') {
      var pdfjs = await import(root.dataset.pdfLibrary);
      pdfjs.GlobalWorkerOptions.workerSrc = root.dataset.pdfWorker;
      var task = pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()), isEvalSupported: false, enableXfa: false });
      var doc;
      try {
        doc = await task.promise;
        if (doc.numPages > 20) throw new Error('Please import a PDF of 20 pages or fewer, or email the original to support@packrift.com.');
        var pages = [];
        for (var p = 1; p <= doc.numPages; p++) {
          var page = await doc.getPage(p), content = await page.getTextContent(), chunks = [], previousY = null;
          content.items.forEach(function (item) {
            if (typeof item.str !== 'string') return;
            var y = Math.round(item.transform[5]);
            if (previousY !== null && Math.abs(y - previousY) > 3) chunks.push('\n');
            chunks.push(item.str + (item.hasEOL ? '\n' : '  ')); previousY = y;
          });
          var pageText = chunks.join('').replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
          // A partially scanned document must not silently lose an order page.
          if (pageText.length < 3) throw new Error('Page ' + p + ' has no readable text. Please email the original PDF so we can check the whole order. Nothing was added.');
          pages.push(pageText); assertLength(pages.join('\n\n'));
        }
        return assertLength(pages.join('\n\n'));
      } finally { await task.destroy(); }
    }
    if (ext === 'xlsx') {
      var ExcelJS = await loadScript(root.dataset.excelLibrary, 'ExcelJS');
      var book = new ExcelJS.Workbook(); await book.xlsx.load(await file.arrayBuffer());
      var sheets = [], rowCount = 0;
      book.worksheets.forEach(function (sheet) {
        if (sheet.state !== 'visible') return;
        var lines = [];
        sheet.eachRow(function (row) {
          if (++rowCount > 300) throw new Error('This workbook has more than 300 filled rows. Import a smaller order sheet or email the original. Nothing was added.');
          var cells = [];
          if (row.cellCount > 40) throw new Error('This sheet is too wide. Keep only the order columns, or email the original. Nothing was added.');
          for (var c = 1; c <= row.cellCount; c++) cells.push(row.getCell(c).text.replace(/[\r\n\t]+/g, ' '));
          lines.push(cells.join('\t'));
          assertLength(lines.join('\n') + sheets.join('\n'));
        });
        if (lines.length) sheets.push('Sheet: ' + sheet.name + '\n' + lines.join('\n'));
      });
      return assertLength(sheets.join('\n\n'));
    }
    throw new Error('Use PDF, Excel (.xlsx), CSV, TSV or TXT. For other files, email the original to support@packrift.com.');
  }
  async function importFile(file) {
    if (busy) return;
    clearError(); busy = true; var run = ++sequence;
    status.textContent = 'Reading your file on this device…';
    fileInput.disabled = true;
    try {
      var result = await extract(file);
      if (run !== sequence) return;
      var combined = text.value.trim() ? text.value.trim() + '\n\n' + result : result;
      assertLength(combined);
      text.value = combined; imported = true; reviewed.checked = false; updateContract();
      text.dispatchEvent(new Event('input', { bubbles: true }));
      status.textContent = 'Text imported from ' + file.name + '. Review it below, including quantities and units. Your original file will not be sent.';
      text.focus();
    } catch (e) {
      var known = e && e.message || '';
      fail(/file|order|text|PDF|workbook|sheet|Choose|import|email/i.test(known) ? known : 'This file could not be read. Try an unlocked PDF, Excel file or CSV, or email the original to support@packrift.com.');
      status.textContent = 'Your existing order details have been kept.';
    } finally { busy = false; fileInput.disabled = false; fileInput.value = ''; }
  }
  fileInput.addEventListener('change', function () { if (fileInput.files[0]) importFile(fileInput.files[0]); });
  // Capture runs before the existing native-contact / quote-engine submit handler.
  form.addEventListener('submit', function (event) {
    updateContract(); clearError();
    var issue = busy ? 'Wait for the file to finish reading before sending.' : '';
    if (!issue && !text.value.trim()) issue = 'Add at least one item to quote.';
    if (!issue && text.value.length > LIMIT) issue = 'Keep the order under 20,000 characters or email the original.';
    if (!issue && window.prQuoteBuildPayload && new Blob([JSON.stringify(window.prQuoteBuildPayload())]).size > 60000) issue = 'This request is too large. Shorten the list or email the original to support@packrift.com.';
    if (!issue && imported && !reviewed.checked) issue = 'Check the imported items and quantities, then tick the review box.';
    if (issue || !form.checkValidity()) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (issue) { fail(issue); error.scrollIntoView({ block: 'center' }); } else form.reportValidity();
    }
  }, true);
  updateContract();
})();
